import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Gamepad2, TrendingUp, Repeat, ShoppingBag } from "lucide-react";

const Stat = ({ label, value, sub, accent }) => (
  <div className="rounded-2xl bg-[#1C1C1F] border border-white/10 p-4">
    <div className="text-xs text-zinc-500">{label}</div>
    <div className="text-2xl font-bold" style={{ color: accent || "#fff" }}>{value}</div>
    {sub && <div className="text-[11px] text-zinc-500 mt-0.5">{sub}</div>}
  </div>
);

export default function GameAnalyticsPanel() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/ceo/game/analytics").then(({ data }) => setD(data)).catch(() => setD({ empty: true })); }, []);
  if (!d) return <div className="text-zinc-500 p-4">Caricamento…</div>;
  if (d.empty) return <div className="text-zinc-500 p-6 text-center" data-testid="game-analytics-empty">🛵 Nessuna partita a Fuma Rider Run ancora registrata.</div>;
  const good = d.d1_retention_pct >= 20 && d.conversion_orders_pct >= 10;
  return (
    <div className="space-y-5" data-testid="game-analytics-panel">
      <div>
        <h2 className="font-display font-bold text-xl flex items-center gap-2"><Gamepad2 className="h-5 w-5 text-[#00E676]" /> Fuma Rider Run — Analytics</h2>
        <p className="text-sm text-zinc-500">Il KPI che conta: il gioco riporta gli utenti su Fuma?</p>
      </div>
      <div className={`rounded-2xl p-4 border ${good ? "border-[#00E676]/40 bg-[#00E676]/10" : "border-amber-500/40 bg-amber-500/10"}`} data-testid="game-insight">
        <div className="font-semibold flex items-center gap-2">{good ? "✅" : "⚠️"} {d.insight}</div>
        <div className="text-xs text-zinc-400 mt-1">Retention D1 {d.d1_retention_pct}% · Conversione ordini {d.conversion_orders_pct}%</div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <Stat label="DAU (oggi)" value={d.dau} accent="#00E676" />
        <Stat label="WAU (7gg)" value={d.wau} accent="#7DF9FF" />
        <Stat label="Giocatori unici" value={d.unique_players} />
        <Stat label="Partite totali" value={d.games_total} sub={`${d.avg_games_per_user}/utente`} />
      </div>
      <div className="text-xs uppercase tracking-widest text-zinc-500 flex items-center gap-1"><Repeat className="h-3.5 w-3.5" /> Ritorno & ingaggio</div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <Stat label="Retention D1" value={`${d.d1_retention_pct}%`} sub="tornano il giorno dopo" accent="#FFD700" />
        <Stat label="Durata media" value={`${d.avg_duration_s}s`} />
        <Stat label="Score medio" value={d.avg_score} />
        <Stat label="Daily Challenge" value={d.daily_challenge_completions} sub="completamenti" />
      </div>
      <div className="text-xs uppercase tracking-widest text-zinc-500 flex items-center gap-1"><ShoppingBag className="h-3.5 w-3.5" /> Conversione verso Fuma</div>
      <div className="grid grid-cols-2 gap-3">
        <Stat label="Giocatori → Ordini" value={`${d.conversion_orders_pct}%`} sub={`${d.players_who_ordered} hanno ordinato`} accent="#00E676" />
        <Stat label="Giocatori → Prenotazioni" value={`${d.conversion_bookings_pct}%`} sub={`${d.players_who_booked} hanno prenotato`} accent="#7DF9FF" />
      </div>
    </div>
  );
}
